import React from "react";
import styles from "./JobListings.module.css";
import files from "../../assets/files.svg";

const JobListings = ({ jobsPositions, t, availabilityMap }) => {
  const handleJobClick = (job) => {
    const url = `/JobDetails?jobId=${job.id}`;
    window.open(url, "_blank");
  };

  const filteredAndSortedJobs = jobsPositions
    .slice()
    .filter((job) => job.statusSelect === 1)
    .sort((a, b) => new Date(b.publicationDate) - new Date(a.publicationDate));

  // console.log("jobsPositions", filteredAndSortedJobs);
  console.log("DATEEEEEE", filteredAndSortedJobs.map((job) => job.publicationDate));

  return (
    <div className={styles.jobListings}>
      {filteredAndSortedJobs.map((job) => (
        <div
          key={job.id}
          onClick={() => handleJobClick(job)}
          className={styles.jobItem}
        >
          <div className={styles.firstChild}>
            <div className={styles.jobIcon}>
              <img src={files} alt="files" />
            </div>
            <div className={styles.jobDetails}>
              <div className={styles.jobTitle}>{job.jobTitle}</div>
              <div className={styles.jobCardDepartment}>
                {job.workingPositionDepartment?.name} • {job.location}
              </div>
              <div className={styles.subtitle}>
                {availabilityMap[job.availabilityToWork] ||
                  job.availabilityToWork}
              </div>
            </div>
          </div>
          <div className={styles.applyBtn}>{t("apply_now")}</div>
        </div>
      ))}
    </div>
  );
};

export default JobListings;
